<script>
  // Kanban/board view for pipeline entities (quest submissions, moderation). Groups
  // rows into lanes by `board.groupBy`, ordered by `board.laneOrder`. Each card shows
  // the compact columns; the lane header badge color comes from the status domain.
  import { Link } from '@inertiajs/svelte'
  import EntitySlot from './entity_slot.svelte'
  import { resolveField, columnsForDensity, SLOTS } from '../../lib/entities/slots.js'
  import { badgeFor } from '../../lib/ui/badges.js'

  let { config, rows = [] } = $props()

  const board = $derived(config.board)
  const statusCol = $derived(config.columns.find((c) => c.slot === SLOTS.STATUS))
  const cardCols = $derived(columnsForDensity(config, 'compact').filter((c) => c.slot !== SLOTS.STATUS))

  const lanes = $derived.by(() => {
    const order = board?.laneOrder ?? []
    const groups = Object.fromEntries(order.map((k) => [k, []]))
    for (const row of rows) {
      const key = String(resolveField(row, board.groupBy))
      if (!(key in groups)) groups[key] = []
      groups[key].push(row)
    }
    return Object.entries(groups)
  })
</script>

<div class="flex gap-4 overflow-x-auto pb-2">
  {#each lanes as [laneKey, laneRows] (laneKey)}
    {@const badge = badgeFor(statusCol?.domain, laneKey)}
    <div class="flex-1 min-w-64 bg-base-200 rounded-box p-3">
      <div class="flex items-center justify-between mb-3 px-1">
        <span class="badge badge-sm {badge.badgeClass}">{badge.label}</span>
        <span class="text-xs text-base-content/50">{laneRows.length}</span>
      </div>
      <div class="space-y-2">
        {#each laneRows as row (row.id)}
          {@const href = row.url}
          {#snippet cardBody()}
            {#each cardCols as col (col.field)}
              <div class="text-sm"><EntitySlot {row} column={col} /></div>
            {/each}
          {/snippet}
          {#if href}
            <Link {href} class="card bg-base-100 border border-base-300 p-3 block hover:border-primary/40 gap-1.5">{@render cardBody()}</Link>
          {:else}
            <div class="card bg-base-100 border border-base-300 p-3 gap-1.5">{@render cardBody()}</div>
          {/if}
        {/each}
        {#if laneRows.length === 0}
          <p class="text-xs text-base-content/40 px-1 py-2">Nothing here.</p>
        {/if}
      </div>
    </div>
  {/each}
</div>
